import { Button, MenuButton, MenuButtonProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export interface FilterBarMenuButtonProps
  extends PropsWithChildren<MenuButtonProps> {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  from?: string;
}

export const FilterMenuButton = ({
  leftIcon,
  rightIcon,
  from,
  ...props
}: FilterBarMenuButtonProps) => (
  <MenuButton
    as={Button}
    bgColor={from === "news-room" ? "white" : "gray.100"}
    border="none"
    borderLeft={{
      base: "none",
      md: from === "news-room" ? "" : "1px solid",
    }}
    borderLeftColor={{
      base: undefined,
      md: "gray.300",
    }}
    color="gray.500"
    fontSize={{
      base: "sm",
      md: 14,
    }}
    fontWeight="normal"
    textAlign="left"
    w={{
      base: "100%",
      md: from === "news-room" ? "auto" : "35%",
    }}
    {...{ leftIcon, rightIcon }}
    {...props}
  />
);
